import React from "react"
import { useTranslation } from "react-i18next"

import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"
import { InputContextType } from "shared/ui/input/Input"
import { TextInput } from "shared/ui/input/text/TextInput"
import { TextInputContextType } from "shared/ui/input/text/TextInputContext"

export const ProjectSearchInput = React.memo(
  ({
    className,
    ...props
  }: Partial<TextInputContextType> &
    Partial<InputContextType> & { className?: string }) => {
    const { t } = useTranslation()
    return (
      <TextInput.Root
        name="searchTerm"
        data-testid="project-search"
        className={`project-search input--elevated ${className || ""}`}
        label={t("General.Search")}
        {...props}
      >
        <TextInput.Label />
        <TextInput.Focus>
          <TextInput.Input
            type="text"
            data-testid="project-search__input"
            className="project-search__input"
          />
          <TextInput.Clear />
          <TextInput.Affix>
            <Icon name={IconName.SEARCH} />
          </TextInput.Affix>
        </TextInput.Focus>
      </TextInput.Root>
    )
  }
)
